idm.registerPageInitFunction(function () {

	function showInfoElem(infoElem) {
		infoElem.prop('hidden',false).hide().slideDown(400, function() {
			updateTriggerElems(infoElem);
		});
	}

	function hideInfoElem(infoElem) {
		infoElem.slideUp(400, function() {
			$(this).attr('hidden',true);
			updateTriggerElems(infoElem);
		});
	}

	function updateInfoElem(triggerElem, infoElem) {
		if(triggerElem.attr('aria-expanded') == 'false') {
			showInfoElem(infoElem);
		}
		else {
			hideInfoElem(infoElem);
		}
	}

	function updateTriggerElems(infoElem) {
		var infoElemId = infoElem.attr('id'),
			triggerElems = $('[aria-controls="'+infoElemId+'"],[aria-owns="'+infoElemId+'"]'),
			infoElemVisible = !infoElem.attr('hidden');

		if (triggerElems.length == 1) {
			triggerElems.attr('aria-expanded',infoElemVisible);
		} else {
			var triggerToShow = triggerElems.filter('[aria-expanded='+infoElemVisible+']'),
				triggerToHide = triggerElems.filter('[aria-expanded='+!infoElemVisible+']');
			triggerToShow.prop('hidden',false).focus();
			triggerToHide.attr('hidden',true);
		}
	}

	$('button.info').click(function() {
		var button = $(this),
			infoElemId = button.attr('aria-controls') || button.attr('aria-owns'),
			infoElem = $('#'+$.escapeSelector(infoElemId));
		updateInfoElem(button, infoElem);
	});
});